import { useEffect, useState } from "react";
import { fetchSupportTicketOpenCount } from "../utils/api";

const POLL_INTERVAL_MS = 60000;

/**
 * Open support ticket count for the current agency company (non-resolved/closed).
 * Shown as a badge on the Support Tickets sidebar link.
 */
export function useSupportTicketOpenCount() {
  const [openCount, setOpenCount] = useState(0);
  const [waitingOnClientCount, setWaitingOnClientCount] = useState(0);

  useEffect(() => {
    let active = true;
    const poll = async () => {
      try {
        const data = await fetchSupportTicketOpenCount();
        if (!active) return;
        setOpenCount(Number(data?.openCount) || 0);
        setWaitingOnClientCount(Number(data?.waitingOnClientCount) || 0);
      } catch {
        if (active) {
          setOpenCount(0);
          setWaitingOnClientCount(0);
        }
      }
    };
    void poll();
    const interval = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      active = false;
      clearInterval(interval);
    };
  }, []);

  return { openCount, waitingOnClientCount, badgeCount: waitingOnClientCount || openCount };
}

export default useSupportTicketOpenCount;
